export enum TooltipArrowPosition {
  BEGIN = "begin",
  CENTER = "center",
  END = "end"
}

// Did not convert to letter case naming for backward compatibility
export enum TooltipTheme {
  Dark = "dark",
  Success = "success",
  Error = "error",
  Share = "share",
  Private = "private",
  Surface = "surface",
  Primary = "primary"
}
